'use client';
import { useEffect } from 'react';

type UseClickOutsideProps = {
  ref?: React.RefObject<HTMLElement>;
  callback: () => void;
  excludeDataAttr?: string[];
};

// TODO move ref creation inside
export function useClickOutside({
  ref,
  callback,
  excludeDataAttr,
}: UseClickOutsideProps) {
  useEffect(() => {
    function handleClickOutside(event: TouchEvent | MouseEvent) {
      if (
        excludeDataAttr?.some((attr) =>
          (event.target as HTMLElement)?.hasAttribute(attr)
        )
      ) {
        callback();
        return;
      }

      if (ref?.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    }

    document.addEventListener('mousedown', handleClickOutside, {
      capture: true,
    });
    document.addEventListener('touchstart', handleClickOutside, {
      capture: true,
    });

    return () => {
      document.removeEventListener('mousedown', handleClickOutside, {
        capture: true,
      });
      document.removeEventListener('touchstart', handleClickOutside, {
        capture: true,
      });
    };
  }, [ref, callback]);
}
